import { useEffect, useState } from "react";

import { useECommerceContext } from "@/components/Product/ECommerce/context/eCommerce.context";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

import { useActionHandlerContext } from "../../context/actionHandler.context";
import { useProductConfigurationContext } from "../../context/productConfiguration.context";
import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";
import { useProductDetail } from "../../hooks/useProductDetail.hook";
import OrderButtonComponent from "./orderButton.component";

type Props = {
    size?: "md" | "sm" | "lg";
    className?: string;
};

const OrderButton = ({ className, size = "md" }: Props) => {
    const [isDisabled, setIsDisabled] = useState(true);
    const isClientSide = useIsClientSide();

    const { isConfigurationValid } = useProductConfigurationContext();
    const { onSubmit } = useActionHandlerContext();
    const { isEcommerceReady } = useECommerceContext();
    const { quantity } = useProductDetail();
    const { isBoxSoldOut, montageParents, sku } = useECommerceProduct();

    useEffect(() => {
        const canSubmit = sku !== "" && quantity > 0;

        setIsDisabled(
            !canSubmit ||
                !isEcommerceReady ||
                !isConfigurationValid ||
                isBoxSoldOut ||
                montageParents.length > 0
        );
    }, [
        isBoxSoldOut,
        isEcommerceReady,
        isConfigurationValid,
        sku,
        quantity,
        montageParents
    ]);

    return (
        <OrderButtonComponent
            className={className}
            isDisabled={!isClientSide || isDisabled}
            onSubmit={onSubmit}
            size={size}
        />
    );
};

export { OrderButton };
